import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    on: translate({ id: 'global.on' }),
    off: translate({ id: 'global.off' }),
    places: translate({ id: 'global.places' }),
    noPlaces: translate({ id: 'globalStyles.places.noPlaces' }),
  }))

  return api
}
